/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
// import FullStory from 'react-fullstory';

import Header from "./header"
import Footer from "./footer"

import "../../styles/base.css"

const Layout = ({
  children,
  pageTitle,
  /** Optional markup next to the page title (e.g. badges). */
  pageTitleAddon,
  /** When true, show verified badge next to the header title (e.g. claimed community page). */
  pageTitleVerified,
  noBackground,
  backgroundImage,
  backgroundImageAlt,
  subtitle,
  enableShare,
  /** When true, main content card does not clip overflow (e.g. dropdowns that extend past the card). */
  contentOverflowVisible,
}) => {
  
  return (
    <div className="bg-gray-100">
      {/*<FullStory org={'14XCBT'} />*/}
      <Header pageTitle={pageTitle} pageTitleAddon={pageTitleAddon} pageTitleVerified={pageTitleVerified} subtitle={subtitle} enableShare={enableShare}
        backgroundImage={backgroundImage} backgroundImageAlt={backgroundImageAlt}
      />

      <main className="relative -mt-32">
        <div className="max-w-7xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">

          {noBackground ? children : (
            <div
              className={`bg-white rounded-lg shadow p-4 sm:p-8 ${
                contentOverflowVisible ? "overflow-visible" : "overflow-hidden"
              }`}
            >
              {children}
            </div>
          )}
        </div>
      </main>

      <Footer/>
    </div>
  )
}

export default Layout
